var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row flex-wrap",style:(`column-gap: ${_vm.gapInPx}px; row-gap: 8px`)},[(!!_vm.content)?_vm._l((_vm.content),function(item,i){return _c('form-node',_vm._g(_vm._b({key:i,class:`d-flex flex-grow-${_vm.grow} w-children-full`},'form-node',item,false),_vm.$listeners))}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }